import * as ActionTypes from '../../actions/allActions'
import { affiliateNormalizer } from '../../normalizers/Normalizers'

const userAffiliatesInit = []
const userAffiliates = (state = userAffiliatesInit, action) => {
	switch(action.type){
		case ActionTypes.SIGNIN_SUCCESS:
		case ActionTypes.CHECKTOKEN_SUCCESS:
		case ActionTypes.ACCOUNT_PROFILE_SUCCESS:
			return action.data.data.attributes.affiliates.data.map(aff => affiliateNormalizer(aff))
		case ActionTypes.LOGOUT:
			return userAffiliatesInit
		default:
			return state
	}
}

export default userAffiliates



// WEBPACK FOOTER //
// ./src/reducers/data/userAffiliates.js